import React, { useEffect, useState } from 'react';
import { CommonTable } from './../common/CommonTableWithGroup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSortUp,faSortDown,faSort } from '@fortawesome/free-solid-svg-icons'
import _ from "lodash"
import { convertPrice, convertToMonth, convertToQuater, getSymbol } from './../../../Utilities';
import {getPercentageChange} from './../../../Utilities'
/** For future use - formatting only */
import * as XLSX from 'xlsx';



// const convertDataSetToColumns=(dataset)=>{
//   let dataArr=[]
//   _.groupBy(dataset,i=>i.)
// }
const monthNames = ["January", "February", "March", "April", "May", "June",
"July", "August", "September", "October", "November", "December"
];




const transformToColumns = (arr) => {
  const cols = Object.keys(arr && arr.length ? arr[0] : []);
  const rows = {};
  arr.forEach((col) => {
    if (!rows[col.reporting_entity_name]) rows[col.reporting_entity_name] = col;    
  });
  const index = cols.indexOf('reporting_entity_name');
  cols.splice(index, 1);
  return [rows, [...new Set(cols)]];
};
const abb={
  negotiated:"",
  percentage:"(%)",
  "per diem":"(PD)",
  "derived":"(D)",
  "fee schedule":"(FS)"
}

const Table=({ dataset ,db,payer})=>{

  const [sortOrder,setSortOrder]=useState(null)
  const [sortid,setSortId]=useState(null)
  const [columnKey,setColumnKey]=useState(null)
  const setSorting=(id,key)=>{
    if(sortid==id){
      if(sortOrder=="desc"){
        setSortOrder("asc")
      }else{
        setSortOrder("desc")
      }
    }else{
      setSortOrder("desc")
      setSortId(id)
      setColumnKey(key)
    }
  }
  const getSortValue=(i,id,key="")=>{
    let currentPayer=payer||JSON.parse(localStorage.getItem('currentUser'))?.payer
  if(i[id]&&(i[id].negotiated_type=="negotiated"||i[id].negotiated_type=="derived")){
  if(key){
  return i[id][key];
  }
  else
  return (i[id].allowed_per_unit-i[currentPayer].allowed_per_unit)/i[currentPayer].allowed_per_unit
  
  }else 
  return ""
  }
    const [rows, cols] = transformToColumns(
      dataset || []
    );


    const transformPayerName=(name)=>{
     
    }

const transformDataSet=(data)=>{
  let currentPayer=payer||JSON.parse(localStorage.getItem('currentUser'))?.payer
  
 
    let obj=_.groupBy(data,i=>i.billing_code)

   return Object.values(obj).map((rows) => {
        let item={ sortScore:0  }
       let currentPayerDataRows=rows.filter(i=>i["reporting_entity_name"]==currentPayer)
       let currentPayerData={
        utilization:parseInt(_.meanBy(currentPayerDataRows,i=>i.utilization)),
        allowed_per_unit:_.meanBy(currentPayerDataRows,i=>Number(i.allowed_per_unit))
       }

       for (const gp of  Object.values((_.groupBy(rows,i=>i.reporting_entity_name)))){
        let row={
          billing_code:gp[0].billing_code,
          reporting_entity_name:gp[0].reporting_entity_name,
          utilization:parseInt(_.meanBy(gp,i=>i.utilization)),
          allowed_per_unit:_.meanBy(gp,i=>Number(i.allowed_per_unit)),
          negotiated_type:gp[0].negotiated_type

        }
        item.billing_code= row.billing_code
        item[row.reporting_entity_name]={...row,
          
          utilization: row.utilization,
          rateDiff:currentPayerData&&row.allowed_per_unit&&(row.negotiated_type=="negotiated"||row.negotiated_type=="derived")?row.allowed_per_unit-currentPayerData.allowed_per_unit:"",
          formated_allowed_per_unit:row.allowed_per_unit&&(row.negotiated_type=="negotiated"||row.negotiated_type=="derived")?convertPrice(row.allowed_per_unit)+abb[row.negotiated_type]:row.allowed_per_unit?convertPrice(row.allowed_per_unit)+abb[row.negotiated_type]:"",
          allowed_per_unit:row.allowed_per_unit,
          percentage:row.allowed_per_unit,
          formated_rateDiff:currentPayerData&&row.allowed_per_unit&&(row.negotiated_type=="negotiated"||row.negotiated_type=="derived")?convertPrice(row.allowed_per_unit-currentPayerData.allowed_per_unit):"",
          formated_savings:currentPayerData&&row.allowed_per_unit&&(row.negotiated_type=="negotiated"||row.negotiated_type=="derived")?convertPrice((row.allowed_per_unit-currentPayerData.allowed_per_unit)*currentPayerData.utilization):"",
          savings:currentPayerData&&row.allowed_per_unit&&(row.negotiated_type=="negotiated"||row.negotiated_type=="derived")?(row.allowed_per_unit-currentPayerData.allowed_per_unit)*currentPayerData.utilization:"",
          formated_percentage:row.allowed_per_unit&&currentPayerData&&(row.negotiated_type=="negotiated"||row.negotiated_type=="derived")?(((row.allowed_per_unit-currentPayerData.allowed_per_unit)*100)/currentPayerData.allowed_per_unit).toFixed(1)+"%":"",
          "total_allowed":row.negotiated_type=="percentage"?row.allowed_per_unit:(row.utilization*row.allowed_per_unit).toFixed(1)}
        if(item[row.reporting_entity_name].allowed_per_unit){
          item.sortScore=item.sortScore+1
        }
       }
        // rows.forEach((row) => {

         


        // })
      
return item
    })
}

console.log(transformDataSet(dataset),"alls data")

let currentPayer=payer||JSON.parse(localStorage.getItem('currentUser'))?.payer

let groupedColumn=_.groupBy(dataset,i=>i.reporting_entity_name)
delete groupedColumn[currentPayer]

useEffect(()=>{
  let firstPayer=Object.keys(_.groupBy(dataset,i=>i.reporting_entity_name)).filter(i=>i.reporting_entity_name!==currentPayer)?.[0]
  setSortOrder("desc")
  setSortId(firstPayer)
  setColumnKey("")
  
  
},[dataset])

 let columns=   [
  {
    Header:currentPayer,
    sticky:"left",
    columns:[
      {
      Header:"Code",
      textHeader:"Code",
      accessor:`${currentPayer}.billing_code`,
      width:100
      },
     
      {
        Header:"Utilization",
        textHeader:"Utilization",
        align:"right",
        accessor:`${currentPayer}.utilization`,
        width:100
      },

      {
        Header:"Allowed Per Unit",
        textHeader:"Allowed Per Unit",
        align:"right",
        accessor:`${currentPayer}.allowed_per_unit`,
        Cell:(props)=><>{convertPrice(props.value)}</>
      },
      
    ]

  },

  ...Object.keys(groupedColumn).map(i=>{
    return(
      {
        Header:i,
    
        columns:[
         
        
          {
            textHeader:"Allowed Per Unit",
            Header:"Allowed Per Unit",
            accessor:`${i}.allowed_per_unit`,
            formattedData:`${i}.formated_allowed_per_unit`,
            align:"right",
            Cell:props=>(props?.row?.original?.[i]?.allowed_per_unit&&(props?.row?.original?.[i]?.["negotiated_type"]=="negotiated"||props?.row?.original?.[i]?.["negotiated_type"]=="derived")?<>{convertPrice(props?.row?.original?.[i]?.allowed_per_unit)+abb[props?.row?.original?.[i]?.["negotiated_type"]]}&nbsp;&nbsp;</>:props?.row?.original?.[i]?.allowed_per_unit?(props?.row?.original?.[i]?.allowed_per_unit)+abb[props?.row?.original?.[i]?.["negotiated_type"]]:"")
          },
          {
            textHeader:"Rate Diff. Per Unit",
            Header:"Rate Diff. Per Unit",
            accessor:`${i}.rateDiff`,
            align:"right",
            formattedData:`${i}.formated_rateDiff`,
            width:160,
            Cell:props=><span style={{color:props?.row?.original?.[i]?.rateDiff<0?"red":"green"}}>{props?.row?.original?.[i]?.rateDiff?convertPrice(Math. abs(props?.row?.original?.[i]?.rateDiff)):null}</span>
          },

          {
            textHeader:"% difference",
            Header:(props)=><div style={{display:"flex",alignItems:"center"}} onClick={()=>{setSorting(i);setColumnKey("")}}>% difference {sortid==i&&columnKey==""?<FontAwesomeIcon icon={sortOrder=="asc"?faSortUp:faSortDown} style={{fontSize:16,marginLeft:2}} />:<FontAwesomeIcon icon={faSort} style={{fontSize:16,marginLeft:2}} />}</div>,
            width:120,
            accessor:`${i}.percentage`,
            formattedData:`${i}.formated_percentage`,
            align:"right",
            Cell:props=>(props?.row?.original?.[i]?.percentage&&(props?.row?.original?.[i]?.["negotiated_type"]=="negotiated"||props?.row?.original?.[i]?.["negotiated_type"]=="derived")?<>{getSymbol(props?.row?.original?.[i]?.percentage,props?.row?.original?.[currentPayer]?.["allowed_per_unit"])}{getPercentageChange(props?.row?.original?.[i]?.percentage,props?.row?.original?.[currentPayer]?.["allowed_per_unit"])}</>:"")
          },
          {
            textHeader:"Total Impact",
            Header:<div style={{display:"flex",alignItems:"center"}} onClick={()=>{setSorting(i);setColumnKey("savings")}}>Total impact {sortid==i&&columnKey=="savings"?<FontAwesomeIcon icon={sortOrder=="asc"?faSortUp:faSortDown} style={{fontSize:16,marginLeft:2}} />:<FontAwesomeIcon icon={faSort} style={{fontSize:16,marginLeft:2}} />}</div>,
            width:130,
            accessor:`${i}.savings`,
            formattedData:`${i}.formated_savings`,
            align:"right",
            Cell:props=><span style={{color:props?.row?.original?.[i]?.savings<0?"red":"green"}}>{props?.row?.original?.[i]?.savings?convertPrice(Math. abs(props?.row?.original?.[i]?.savings)):null}</span>
          }
          
        ]
   
      }
    )
  }),
     
         
         


        
    ]
    const downloadExcel = (data) => {

      let accessors=[]
       let firstRow=
        {
        
         
      
        }
      
        const merge = [
          { s: { r: 0, c: 0 }, e: { r: 0, c:2 } },
      
        ];

        columns.map((col,index)=>{
          let mergeObj=  { s: { r: 0, c:3+ ((index-1)*col.columns.length) }, e: { r: 0, c:2+(index*col.columns.length) } }
          if(index)
          merge.push(mergeObj)
         col.columns.map((i,ind)=>{
          if(ind==0){
            firstRow[col.Header]=i.textHeader
            accessors.push({
                             name:col.Header,
                              accessor:i.accessor
                             })
          }
          else{
            firstRow[`__Empty_${ind}${col.Header}`]=i.textHeader
            accessors.push({
              name:`__Empty_${ind}${col.Header}`,
               accessor:i.formattedData?i.formattedData:i.accessor
              })
          }
         
         })

        })
console.log(merge,firstRow)

  

//         _.uniqBy(dataset,i=>i.negotiated_type).map((item,index)=>{
//           let months= _.orderBy(_.uniqBy(dataset,i=>i.month),i=>(monthNames.findIndex(ind=>ind==i.month)),['asc'])
//          let mergeObj=  { s: { r: 0, c: 2+(index*months.length) }, e: { r: 0, c: months.length-1+2+(index*months.length) } }
// merge.push(mergeObj)
//          months.map((i,index)=>{
//             if(index>0){
//               firstRow[`__Empty_${item.negotiated_type}_${i.month}`]=i.month
//               accessors.push({
//                 name:`__Empty_${item.negotiated_type}_${i.month}`,
//                 accessor:item.negotiated_type+"."+i.month
//               })
//             }
//             else{
//               firstRow[item.negotiated_type]=i.month
//               accessors.push({
//                 name:`${item.negotiated_type}`,
//                 accessor:item.negotiated_type+"."+i.month
//               })
//             }
//            })

//         })
       
      
      
      
      
      
       let formatedJson=[firstRow]
       
       _.map(data,item=>{
      let obj={}
      
      accessors.map(i=>{
        obj[i.name]=_.get(item,i.accessor)
      })
      formatedJson.push(obj)
      
       })
          
                const worksheet = XLSX.utils.json_to_sheet(formatedJson);
                worksheet['!merges'] = merge;
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
                //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
                XLSX.writeFile(workbook, 'DataSheet.xlsx');
              };

    const downoadRaw=(data)=>{
                const worksheet = XLSX.utils.json_to_sheet(data);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                //let buffer = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
                //XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
                XLSX.writeFile(workbook, 'DataSheet.xlsx');
              }
              

    return (
  <div >
   

              <span className="downloadBtn ">
								<svg
									width="20"
									height="20"
									viewBox="0 0 123 121"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clipPath="url(#clip0_4_39)">
										<path
											d="M84.58 47C85.2961 46.2624 86.1525 45.6755 87.0988 45.2737C88.0451 44.872 89.0621 44.6635 90.0902 44.6607C91.1182 44.6578 92.1364 44.8605 93.0849 45.257C94.0335 45.6534 94.8931 46.2355 95.6133 46.9691C96.3336 47.7026 96.8998 48.5728 97.2788 49.5285C97.6578 50.4841 97.8418 51.5059 97.82 52.5337C97.7983 53.5615 97.5712 54.5746 97.1522 55.5133C96.7332 56.4521 96.1306 57.2975 95.38 58L66.09 86.88C64.6464 88.2981 62.7036 89.0927 60.68 89.0927C58.6564 89.0927 56.7136 88.2981 55.27 86.88L26.4 58.37C24.9413 56.9365 24.1118 54.9823 24.094 52.9372C24.0762 50.8921 24.8715 48.9237 26.305 47.465C27.7385 46.0063 29.6927 45.1768 31.7378 45.159C33.7829 45.1412 35.7513 45.9365 37.21 47.37L53.1 63.12L53.26 7.65C53.3468 5.65118 54.2063 3.76414 55.6572 2.38657C57.1081 1.009 59.0371 0.248502 61.0378 0.265358C63.0384 0.282213 64.9544 1.0751 66.3818 2.47692C67.8093 3.87874 68.6369 5.78 68.69 7.78L68.54 62.78L84.58 47ZM0 113.48L0.1 83.3C0.0733066 82.2639 0.255513 81.233 0.635757 80.2689C1.016 79.3047 1.58649 78.427 2.31323 77.688C3.03996 76.9491 3.90804 76.364 4.86573 75.9677C5.82341 75.5715 6.85109 75.3721 7.88748 75.3815C8.92387 75.3909 9.94776 75.6089 10.8981 76.0225C11.8484 76.4361 12.7058 77.0368 13.419 77.7888C14.1322 78.5408 14.6866 79.4288 15.0493 80.3997C15.412 81.3706 15.5755 82.4046 15.53 83.44L15.46 105.44C46.1267 105.5 76.7633 105.5 107.37 105.44L107.44 83.32C107.459 81.2725 108.29 79.3163 109.751 77.8816C111.212 76.447 113.183 75.6514 115.23 75.67C117.277 75.6886 119.234 76.5197 120.668 77.9806C122.103 79.4415 122.899 81.4125 122.88 83.46L122.78 113.46H122.69C122.6 115.432 121.758 117.294 120.337 118.663C118.916 120.032 117.023 120.804 115.05 120.82C79.23 120.887 43.4367 120.887 7.67 120.82C5.69389 120.814 3.79555 120.049 2.36785 118.683C0.940148 117.317 0.0923821 115.454 0 113.48H0Z"
											fill="#B54491"
										/>
									</g>
									<defs>
										<clipPath id="clip0_4_39">
											<rect width="122.88" height="120.89" fill="white" />
										</clipPath>
									</defs>
								</svg>
								<span className="ml-5" onClick={()=>downoadRaw(dataset)}>
									Raw Data
								</span>
							</span>
              <span className="downloadBtn ">
								<svg
									width="20"
									height="20"
									viewBox="0 0 123 121"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clipPath="url(#clip0_4_39)">
										<path
											d="M84.58 47C85.2961 46.2624 86.1525 45.6755 87.0988 45.2737C88.0451 44.872 89.0621 44.6635 90.0902 44.6607C91.1182 44.6578 92.1364 44.8605 93.0849 45.257C94.0335 45.6534 94.8931 46.2355 95.6133 46.9691C96.3336 47.7026 96.8998 48.5728 97.2788 49.5285C97.6578 50.4841 97.8418 51.5059 97.82 52.5337C97.7983 53.5615 97.5712 54.5746 97.1522 55.5133C96.7332 56.4521 96.1306 57.2975 95.38 58L66.09 86.88C64.6464 88.2981 62.7036 89.0927 60.68 89.0927C58.6564 89.0927 56.7136 88.2981 55.27 86.88L26.4 58.37C24.9413 56.9365 24.1118 54.9823 24.094 52.9372C24.0762 50.8921 24.8715 48.9237 26.305 47.465C27.7385 46.0063 29.6927 45.1768 31.7378 45.159C33.7829 45.1412 35.7513 45.9365 37.21 47.37L53.1 63.12L53.26 7.65C53.3468 5.65118 54.2063 3.76414 55.6572 2.38657C57.1081 1.009 59.0371 0.248502 61.0378 0.265358C63.0384 0.282213 64.9544 1.0751 66.3818 2.47692C67.8093 3.87874 68.6369 5.78 68.69 7.78L68.54 62.78L84.58 47ZM0 113.48L0.1 83.3C0.0733066 82.2639 0.255513 81.233 0.635757 80.2689C1.016 79.3047 1.58649 78.427 2.31323 77.688C3.03996 76.9491 3.90804 76.364 4.86573 75.9677C5.82341 75.5715 6.85109 75.3721 7.88748 75.3815C8.92387 75.3909 9.94776 75.6089 10.8981 76.0225C11.8484 76.4361 12.7058 77.0368 13.419 77.7888C14.1322 78.5408 14.6866 79.4288 15.0493 80.3997C15.412 81.3706 15.5755 82.4046 15.53 83.44L15.46 105.44C46.1267 105.5 76.7633 105.5 107.37 105.44L107.44 83.32C107.459 81.2725 108.29 79.3163 109.751 77.8816C111.212 76.447 113.183 75.6514 115.23 75.67C117.277 75.6886 119.234 76.5197 120.668 77.9806C122.103 79.4415 122.899 81.4125 122.88 83.46L122.78 113.46H122.69C122.6 115.432 121.758 117.294 120.337 118.663C118.916 120.032 117.023 120.804 115.05 120.82C79.23 120.887 43.4367 120.887 7.67 120.82C5.69389 120.814 3.79555 120.049 2.36785 118.683C0.940148 117.317 0.0923821 115.454 0 113.48H0Z"
											fill="#B54491"
										/>
									</g>
									<defs>
										<clipPath id="clip0_4_39">
											<rect width="122.88" height="120.89" fill="white" />
										</clipPath>
									</defs>
								</svg>
								<span className="ml-5" onClick={()=>downloadExcel(sortOrder?_.orderBy(transformDataSet(dataset),i=>getSortValue(i,sortid,columnKey),[sortOrder]):_.orderBy(transformDataSet(dataset),["sortScore"],["desc"])|| [])}>
									Formatted Data
								</span>
           
							</span>
              <div style={{overflow:"scroll",height:"80vh",width:"100%"}}>
              <CommonTable
              sticky
              stickyTop={0}
            columns={columns}
            data={sortOrder&&sortid?_.orderBy(transformDataSet(dataset),i=>getSortValue(i,sortid,columnKey),[sortOrder]):_.orderBy(transformDataSet(dataset),["sortScore"],["desc"])|| []}
            className='zignaAi_table_1 zignaAi_newTable'
          />
          </div>
  </div>
         
     
    );
                }

                export default Table

